import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const TvHome = () => {
  return (
    <div>
      <Navbar />
      TVHome
      <Footer />

    </div>
  )
}

export default TvHome
